<template>
<div class="first-allocation">
  <el-card class="box-card" shadow="never">
    <div slot="header" class="clearfix"><span>指标列表</span></div>
    <el-form ref="form" :inline="false" :model="form">
      <el-form-item>
        <div style="height:54vh;overflow: auto;">
          <el-tree :data="locationList" show-checkbox default-expand-all node-key="resourceId" ref="tree" :default-checked-keys="defaultChecked" highlight-current :props="defaultProps"></el-tree>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="addConfigResourceTree">保存指标</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</div>
</template>

<script>
import RESOURCEAPI from '@/api/resource';
export default {
  props: {
    groupId: {
      type: [Number, String]
    }
  },
  data() {
    return {
      form: {},
      defaultProps: {
        children: 'children',
        label: 'resourceNameShow'
      },
      locationList: [],
      defaultChecked: []
    };
  },
  created() {
    this.searchOrganizationResourceTree();
  },
  methods: {
    //项目列表
    searchOrganizationResourceTree() {
      let params = {
        groupId: this.groupId
      };
      RESOURCEAPI.searchOrganizationResourceTree(params).then(res => {
        if (res.data.code == 200) {
          this.locationList = res.data.data;
          let result = this.COMM.getAllNode(this.locationList);
          this.defaultChecked = [];
          result.forEach(item => {
            if (item.checked == 1) {
              this.defaultChecked.push(item.resourceId);
            }
          });
        }
      });
    },
    //添加资源配置(组织资源配置、项目资源配置)
    addConfigResourceTree() {
      let checkedNode = this.$refs.tree.getCheckedNodes();
      let params = {
        configType: 1,
        dataConfigId: this.groupId,
        resourceIds: []
      }
      checkedNode.forEach(item => {
        params.resourceIds.push(item.resourceId);
      })
      RESOURCEAPI.addConfigResourceTree(params).then(res => {
        if (res.data.code == 200) {
          this.$message.success('操作成功');
          this.searchOrganizationResourceTree();
        }
      })
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/boss/group/firstallocation.vue